import { ApiClient, type CursorPagedResponse } from '@/infra/api-client'
import type {
  AcceptSection7216Request,
  ListSection7216AcceptancesRequest,
  Section7216AcceptanceResource,
  Section7216Resource,
} from '@/features/account/api/resources/section-7216'

export class Section7216Api extends ApiClient {
  getLatest(signal?: AbortSignal): Promise<Section7216Resource> {
    return this._get(`v3/section-7216/`, undefined, { signal })
  }

  getById(id: string, signal?: AbortSignal): Promise<Section7216Resource> {
    return this._get(`v3/section-7216/${id}`, undefined, { signal })
  }

  getLatestAcceptance(
    signal?: AbortSignal,
  ): Promise<Section7216AcceptanceResource> {
    return this._get(`v3/section-7216-acceptance/latest`, undefined, {
      signal,
    })
  }

  listAcceptances(
    req: ListSection7216AcceptancesRequest,
    signal?: AbortSignal,
  ): Promise<CursorPagedResponse<Section7216AcceptanceResource>> {
    const params = ApiClient.createSearchParamsFromPageQuery(req)
    return this._get(`v3/section-7216-acceptance`, params, { signal })
  }

  accept(
    request: AcceptSection7216Request,
  ): Promise<Section7216AcceptanceResource> {
    return this._post(`v3/section-7216-acceptance/accept`, request)
  }
}
